<template>
  <div class="content" v-bind:class="[{ 's-full-list-active': fullListActive}]">
    <h1><span>Seattle city council districts</span> between <span>{{startDate}}</span> and <span>{{endDate}}</span> with the <strong>highest</strong>...</h1>

    <div class="well collisions-filters">
      <h2 class="well-title collisions-filters-title">
        <span>Filter collisions</span>
      </h2>
      <div class="well-content">
        <FilterDate :default-option="{ key: 'all', label: 'Since January 1st, 2006' }"></FilterDate>
        <FilterSubmitButton :routeName="'cityCouncilDistrictRanks'" 
                            :routeParams="routeParams" 
                            v-bind:class="[{'is-loading': isLoading}]"></FilterSubmitButton>
      </div>
    </div>
    
    <div class="l-grid l-grid-medium">
        <Costs :card-color="'green'"
               :card-icon="'attach_money'"
               :full-list-toggle-dispatch="'cityCouncilDistrictRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'cityCouncilDistrictRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/districts/city/ranks/costs/economic/desc',
                                     pageTitle: 'Seattle economic costs by city council district between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Economic costs',
                                     ths: ['Rank', 'Council district', 'Amount'],
                                     link: 'cityCouncilDistrict',
                                     titleIcon: 'attach_money',
                                     color: 'green',
                                     prefix: '$',
                                     barColors: this.$store.getters.green.light.a
                                  }"
               :getter="'cityCouncilDistrictRanksView/costs/get'"
               :title="'Economic costs'"
               :bar-color="this.$store.getters.green.light.a"
               :legend-color="'green'"
               :legend-link="'cityCouncilDistrict'"
               :label-prefix="' $'"></Costs>

        <TotalCollisions :card-color="'yellow'"
               :card-icon="'flare'"
               :full-list-toggle-dispatch="'cityCouncilDistrictRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'cityCouncilDistrictRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/districts/city/ranks/totalcollisions/desc',
                                     pageTitle: 'Seattle total collisions by city council district between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Total collisions',
                                     ths: ['Rank', 'Council district', 'Amount'],
                                     link: 'cityCouncilDistrict',
                                     titleIcon: 'warning',
                                     color: 'yellow',
                                     barColors: this.$store.getters.yellow.default
                                   }"
               :getter="'cityCouncilDistrictRanksView/totalCollisions/get'"
               :title="'Total collisions'"
               :bar-color="this.$store.getters.yellow.default"
               :legend-color="'yellow'"
               :legend-link="'cityCouncilDistrict'"></TotalCollisions>

        <Fatalities :card-color="'black'"
               :full-list-toggle-dispatch="'cityCouncilDistrictRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'cityCouncilDistrictRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/districts/city/ranks/severity/5/desc',
                                     pageTitle: 'Seattle fatalities by city council district between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Fatalities',
                                     ths: ['Rank', 'Council district', 'Amount'],
                                     link: 'cityCouncilDistrict',
                                     color: 'black',
                                     barColors: this.$store.getters.black.dark.b
                                   }"
               :getter="'cityCouncilDistrictRanksView/fatalities/get'"
               :title="'Fatalities'"
               :bar-color="this.$store.getters.black.dark.b"
               :legend-color="'black'"
               :legend-link="'cityCouncilDistrict'"></Fatalities>

        <SeriousInjuries :card-color="'red'"
               :full-list-toggle-dispatch="'cityCouncilDistrictRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'cityCouncilDistrictRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/districts/city/ranks/severity/4/desc',
                                     pageTitle: 'Seattle serious injuries by city council district between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Serious injuries',
                                     ths: ['Rank', 'Council district', 'Amount'],
                                     link: 'cityCouncilDistrict',
                                     color: 'red',
                                     barColors: this.$store.getters.red.dark.b
                                   }"
               :getter="'cityCouncilDistrictRanksView/seriousInjuries/get'"
               :title="'Number of serious injuries'"
               :bar-color="this.$store.getters.red.dark.b"
               :legend-color="'red'"
               :legend-link="'cityCouncilDistrict'"></SeriousInjuries>

        <Injuries :card-color="'red'"
               :full-list-toggle-dispatch="'cityCouncilDistrictRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'cityCouncilDistrictRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/districts/city/ranks/severity/1/desc',
                                     pageTitle: 'Seattle injuries by city council district between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Injuries',
                                     ths: ['Rank', 'Council district', 'Amount'],
                                     link: 'cityCouncilDistrict',
                                     color: 'red',
                                     barColors: this.$store.getters.red.dark.a
                                   }"
               :getter="'cityCouncilDistrictRanksView/injuries/get'"
               :title="'Number of injuries'"
               :bar-color="this.$store.getters.red.dark.a"
               :legend-color="'red'"
               :legend-link="'cityCouncilDistrict'"></Injuries>

        <PossibleInjuries :card-color="'red'"
               :full-list-toggle-dispatch="'cityCouncilDistrictRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'cityCouncilDistrictRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/districts/city/ranks/severity/3/desc',
                                     pageTitle: 'Seattle possible injuries by city council district between ' + startDate + ' &amp; ' + endDate,
                                     title: 'possible injuries',
                                     ths: ['Rank', 'Council district', 'Amount'],
                                     link: 'cityCouncilDistrict',
                                     color: 'red',
                                     barColors: this.$store.getters.red.light.b
                                   }"
               :getter="'cityCouncilDistrictRanksView/possibleInjuries/get'"
               :title="'Collisions with possible injuries'"
               :bar-color="this.$store.getters.red.light.b"
               :legend-color="'red'"
               :legend-link="'cityCouncilDistrict'"></PossibleInjuries>

        <PeopleInvolved :card-color="'orange'"
               :card-icon="'person'"
               :full-list-toggle-dispatch="'cityCouncilDistrictRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'cityCouncilDistrictRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/districts/city/ranks/who/personcount/desc',
                                     pageTitle: 'Seattle people involved by city council district between ' + startDate + ' &amp; ' + endDate,
                                     title: 'People involved',
                                     ths: ['Rank', 'Council district', 'Amount'],
                                     link: 'cityCouncilDistrict',
                                     color: 'orange',
                                     barColors: this.$store.getters.orange.dark.a
                                   }"
               :getter="'cityCouncilDistrictRanksView/possibleInjuries/get'"
               :title="'Number of people involved'"
               :bar-color="this.$store.getters.orange.dark.a"
               :legend-color="'orange'"
               :legend-link="'cityCouncilDistrict'"></PeopleInvolved>
        
        <PeopleWalking :card-color="'orange'"
               :card-icon="'directions_walk'"
               :full-list-toggle-dispatch="'cityCouncilDistrictRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'cityCouncilDistrictRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/districts/city/ranks/who/pedcount/desc',
                                     pageTitle: 'Seattle pedestrians involved by city council district between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Pedestrians involved',
                                     ths: ['Rank', 'Council district', 'Amount'],
                                     link: 'cityCouncilDistrict',
                                     color: 'orange',
                                     barColors: this.$store.getters.orange.light.a
                                   }"
               :getter="'cityCouncilDistrictRanksView/peopleWalking/get'"
               :title="'Number of pedestrians involved'"
               :bar-color="this.$store.getters.orange.light.a"
               :legend-color="'orange'"
               :legend-link="'cityCouncilDistrict'"></PeopleWalking>

        <PeopleBiking :card-color="'orange'"
               :card-icon="'directions_bike'"
               :full-list-toggle-dispatch="'cityCouncilDistrictRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'cityCouncilDistrictRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/districts/city/ranks/who/pedcylcount/desc',
                                     pageTitle: 'Seattle people biking by city council district between ' + startDate + ' &amp; ' + endDate,
                                     title: 'People biking',
                                     ths: ['Rank', 'Council district', 'Amount'],
                                     link: 'cityCouncilDistrict',
                                     color: 'orange',
                                     barColors: this.$store.getters.orange.light.b
                                   }"
               :getter="'cityCouncilDistrictRanksView/peopleBiking/get'"
               :title="'Number of people biking involved'"
               :bar-color="this.$store.getters.orange.light.b"
               :legend-color="'orange'"
               :legend-link="'cityCouncilDistrict'"></PeopleBiking>

        <DistractedDriving :card-color="'purple'"
               :card-icon="'visibility_off'"
               :full-list-toggle-dispatch="'cityCouncilDistrictRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'cityCouncilDistrictRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/districts/city/ranks/who/inattentionind/desc',
                                     pageTitle: 'Seattle distracted driving by city council district between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Distracted driving',
                                     ths: ['Rank', 'Council district', 'Amount'],
                                     link: 'cityCouncilDistrict',
                                     color: 'purple',
                                     barColors: this.$store.getters.purple.dark.a
                                   }"
               :getter="'cityCouncilDistrictRanksView/distractedDriving/get'"
               :title="'Cases of distracted driving'"
               :bar-color="this.$store.getters.purple.dark.a"
               :legend-color="'purple'"
               :legend-link="'cityCouncilDistrict'"></DistractedDriving>

        <UnderTheInfluence :card-color="'purple'"
               :card-icon="'blur_on'"
               :full-list-toggle-dispatch="'cityCouncilDistrictRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'cityCouncilDistrictRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/districts/city/ranks/who/underinfl/desc',
                                     pageTitle: 'Seattle DUI by city council district between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Driving under the influence',
                                     ths: ['Rank', 'Council district', 'Amount'],
                                     link: 'cityCouncilDistrict',
                                     color: 'purple',
                                     barColors: this.$store.getters.purple.light.a
                                   }"
               :getter="'cityCouncilDistrictRanksView/underTheInfluence/get'"
               :title="'Cases of DUI'"
               :bar-color="this.$store.getters.purple.light.a"
               :legend-color="'purple'"
               :legend-link="'cityCouncilDistrict'"></UnderTheInfluence>
        
        <PropertyDamageOnly :card-color="'blue'"
               :card-icon="'toll'"
               :full-list-toggle-dispatch="'cityCouncilDistrictRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'cityCouncilDistrictRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/districts/city/ranks/severity/2/desc',
                                     pageTitle: 'Seattle property damage only by city council district between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Property damage only',
                                     ths: ['Rank', 'Council district', 'Amount'],
                                     link: 'cityCouncilDistrict',
                                     color: 'blue',
                                     barColors: this.$store.getters.blue.light.a
                                   }"
               :getter="'cityCouncilDistrictRanksView/propertyDamageOnly/get'"
               :title="'Property damage only collisions'"
               :bar-color="this.$store.getters.blue.light.a"
               :legend-color="'blue'"
               :legend-link="'cityCouncilDistrict'"></PropertyDamageOnly>

        <ParkedCarsHit :card-color="'blue'"
               :card-icon="'local_parking'"
               :full-list-toggle-dispatch="'cityCouncilDistrictRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'cityCouncilDistrictRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/districts/city/ranks/who/hitparkedcar/desc',
                                     pageTitle: 'Seattle parked cars hit by city council district between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Parked cars hit',
                                     ths: ['Rank', 'Council district', 'Amount'],
                                     link: 'cityCouncilDistrict',
                                     color: 'blue',
                                     barColors: this.$store.getters.blue.light.a
                                   }"
               :getter="'cityCouncilDistrictRanksView/parkedCarsHit/get'"
               :title="'Number of parked cars hit'"
               :bar-color="this.$store.getters.blue.light.a"
               :legend-color="'blue'"
               :legend-link="'cityCouncilDistrict'"></ParkedCarsHit>

        <Speeding :card-color="'teal'"
               :card-icon="'fast_forward'"
               :full-list-toggle-dispatch="'cityCouncilDistrictRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'cityCouncilDistrictRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/districts/city/ranks/who/speeding/desc',
                                     pageTitle: 'Seattle speeding by city council district between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Speeding',
                                     ths: ['Rank', 'Council district', 'Amount'],
                                     link: 'cityCouncilDistrict',
                                     color: 'teal',
                                     barColors: this.$store.getters.teal.light.a
                                   }"
               :getter="'cityCouncilDistrictRanksView/speeding/get'"
               :title="'Cases of speeding'"
               :bar-color="this.$store.getters.teal.light.a"
               :legend-color="'teal'"
               :legend-link="'cityCouncilDistrict'"></Speeding>
    </div>

    <SeattleCityCouncilInformation></SeattleCityCouncilInformation>

    <FullList :getters="{ active: 'cityCouncilDistrictRanksView/fullList/active',
                          fetch: 'cityCouncilDistrictRanksView/fullList/fetch',
                          filters: 'cityCouncilDistrictRanksView/fullList/filters',
                          get: 'cityCouncilDistrictRanksView/fullList/get',
                          options: 'cityCouncilDistrictRanksView/fullList/options',
                          reset: 'cityCouncilDistrictRanksView/fullList/reset',
                          toggleActive: 'cityCouncilDistrictRanksView/fullList/toggleActive'
                        }"></FullList>
  </div>
</template>

<script>
import Moment from 'moment'

import FilterDate from '@/components/FilterDate'
import FilterSubmitButton from '@/components/FilterSubmitButton'
import Ranks from '@/components/barCharts/Ranks'
import FullList from '@/components/trays/FullList'

import SeattleCityCouncilInformation from '@/components/SeattleCityCouncilInformation'

export default {
  name: 'cityCouncilDistrictRanks',

  data: function () {
    return {
      dateToggleLabel: 'Custom date range'
    }
  },

  components: {
    'FilterDate': FilterDate,
    'FilterSubmitButton': FilterSubmitButton,
    'SeattleCityCouncilInformation': SeattleCityCouncilInformation,
    'Costs': Ranks,
    'TotalCollisions': Ranks,
    'Fatalities': Ranks,
    'SeriousInjuries': Ranks,
    'Injuries': Ranks,
    'PossibleInjuries': Ranks,
    'PeopleInvolved': Ranks,
    'PeopleWalking': Ranks,
    'PeopleBiking': Ranks,
    'DistractedDriving': Ranks,
    'UnderTheInfluence': Ranks,
    'PropertyDamageOnly': Ranks,
    'ParkedCarsHit': Ranks,
    'Speeding': Ranks,
    'FullList': FullList
  },

  mounted: function () {
    this.$store.dispatch('cityCouncilDistrictRanksView/resetResults')
    this.$store.dispatch('cityCouncilDistrictRanksView/setFilters')
    this.$store.dispatch('cityCouncilDistrictRanksView/fetchAll', this.filters)
    document.getElementById('app').classList.add('city-council-district-ranks')
  },

  computed: {
    filters () {
      return this.$store.getters['cityCouncilDistrictRanksView/filters']
    },

    startDate () {
      return Moment(this.resultsFilters.startDate).format('MMMM Do, YYYY')
    },

    endDate () {
      return Moment(this.resultsFilters.endDate).format('MMMM Do, YYYY')
    },

    routeParams () {
      return {sd: this.filters.startDate, ed: this.filters.endDate}
    },

    resultsFilters () {
      return this.$store.getters['cityCouncilDistrictRanksView/resultsFilters']
    },

    isLoading () {
      return (this.$store.getters['cityCouncilDistrictRanksView/costs/get'].length > 0) ? 0 : 1
    },

    fullListActive () {
      return this.$store.getters['cityCouncilDistrictRanksView/fullList/active']
    }
  },

  watch: {
    $route: function (to, from) {
      this.$store.dispatch('cityCouncilDistrictRanksView/resetResults')
      this.$store.dispatch('cityCouncilDistrictRanksView/setFilters')
      this.$store.dispatch('cityCouncilDistrictRanksView/fetchAll', this.filters)
    }
  },

  beforeRouteLeave (to, from, next) {
    if (to.name !== 'cityCouncilDistrictRanks') {
      document.getElementById('app').classList.remove('city-council-district-ranks')
    }
    next()
  }
}
</script>

<style lang="scss">
@import "./src/sass/components/FilterSubmitButton.scss";
@import "./src/sass/views/neighborhood-ranks.scss";
</style>



// WEBPACK FOOTER //
// CityCouncilDistrictRanks.vue?dcd127b4